import Channels from "../base/channels";
import Component from "gia/Component";
import gsap from "gsap";
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;
    //
    this.funcLaunch = this._reveal.bind(this);

    this._fx();
    Channels.on("launcher::exit", this.funcLaunch);
    Channels.on("transition::end", this.funcLaunch);
  }

  _fx() {
    this.animate();
  }

  _reveal() {}

  animate() {
    // this.animation = gsap.timeline();
    // this.animation.add([
    //   gsap.fromTo(
    //     this.ref.hideout,
    //     {
    //       autoAlpha: 1,
    //     },
    //     {
    //       autoAlpha: 0,
    //       ease: "cubic.out",
    //       duration: 1,
    //     }
    //   ),
    // ]);
  }

  unmount() {
    Channels.removeListener("launcher::exit", this.funcLaunch);
    Channels.removeListener("transition::end", this.funcLaunch);
  }
}
